import React from "react";
import { Button, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import CardView from "../../../components/common/CardView";
import Search from "../../../components/Search";
import Table from "../../../components/Table";
import withRouter from "../../../withRouter";
import AuditLogsPresenter from "./AuditLogsPresenter";
import { renderToStaticMarkup } from "react-dom/server";
import DateRangePicker from "../../../components/common/DateRangePicker";
import { DatePicker, Space } from "antd";

class AuditLogsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AuditLogsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { objects: [], count: 0, limit: 20, current: 1 };
  }

  getCollectionName() {
    return "audit_logs";
  }
  printContent(objects) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div style={{ margin: "0 2rem" }}>
          <table>
            <thead>
              <tr>
                <td colSpan="3" style={{ height: "10rem" }}></td>
              </tr>
              <tr>
                <th>Date</th>
                <th>User</th>
                <th>Activity</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {objects.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.logDate}</td>
                    <td>{item.user}</td>
                    <td>{item.activity}</td>
                    <td>{item.message}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    const GeneratePDF = async () => {
      // const objects = await findObjectUseCase().execute(
      //   this.getCollectionName()
      // );
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";

      document.body.appendChild(iframe);

      const iframeDoc = iframe.contentWindow.document;
      const printContentElement = this.printContent(objects);
      const printContentHTML = renderToStaticMarkup(printContentElement);

      iframeDoc.open();
      iframeDoc.write(
        `<html><head>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 1.1rem;
            text-align: left;
          }
          th, td {
          padding-top: .5rem;
          padding-bottom: .5rem;
          border-bottom: 1px solid #ddd;
          padding-right: .5rem;
          padding-left: .5rem;
          }
          
            .header {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              width: 100%;
              height: 125px;
              z-index: 1000;
            }
            @page {
              margin: 0;
              size: auto;
            }
@media print {
        th {
          background-color: #2e6bc7 !important;
          color: #fff;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        tr:nth-child(even) td {
          background-color: #e1e7f0 !important;
            -webkit-print-color-adjust: exact;
        }
        tr:nth-child(odd) td {
            -webkit-print-color-adjust: exact;
        }
      }
        </style></head><body>`
      );

      // Adding the image as a fixed header
      iframeDoc.write(
        `<div class='header'>
          <div style="padding: 1rem; text-align: center;">
            <img src="${"/BI.png"}" width="100%" height="125" />
          </div>
        </div>`
      );
      iframeDoc.write(printContentHTML);

      // Adding the script for the onload callback function
      iframeDoc.write(`<script>
        window.onload = function() {
            window.print();
            window.onafterprint = function() {
              window.close();
            }
        };
      </script>`);
      iframeDoc.write("</body></html>");
      iframeDoc.close();
    };

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4 mt-5">
              <div
                className="d-flex mb-4 mt-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} System Administration {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>

              <CardView style={{ borderRadius: 0 }}>
                {/* <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                /> */}
                <div className="row d-flex align-items-center">
                  <div className="col-md-6 mt-1 ">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                  <div className="col-md-6 mt-1 border-box">
                    <DateRangePicker
                      fields={["createdAt", "updatedAt"]}
                      onFilter={(filterObj) => {
                        if (Object.keys(filterObj).length > 0) {
                          const updatedAtDate = new Date(
                            filterObj.updatedAt.$lte
                          );
                          updatedAtDate.setDate(updatedAtDate.getDate() + 1);

                          const updatedFilterObj = {
                            ...filterObj,
                            updatedAt: {
                              $lte: updatedAtDate.toISOString().split("T")[0],
                            },
                          };
                          console.log("UPDTE: ", updatedFilterObj);
                          this.filterSubmit(updatedFilterObj);
                        } else {
                          this.filterSubmit(filterObj);
                        }
                      }}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      {/* <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => GeneratePDF()}
                      >
                        <i className="bi bi-filetype-pdf" /> PDF
                      </Button> */}
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GenerateExcel()}
                      >
                        <i className="bi bi-filetype-exe" /> Excel
                      </Button>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GenerateCSV()}
                      >
                        <i className="bi bi-filetype-csv" /> CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                // refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "createdAt", "updatedAt"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(AuditLogsPage);
